'use client';

import { SubmitButton } from 'app/components/SubmitButton';
import { Message } from 'app/types';
import { Alert, Button, Label, Modal, TextInput, Textarea } from 'flowbite-react';
import { useState } from 'react';
import { FaRegFlag } from "react-icons/fa";
import { flagContent } from './ServerActions';
import { useFormState } from 'react-dom';

type ReportContentProps = {
    alreadyReported: boolean,
    jobId: string,
}

const initialMessage: Message | undefined = undefined;

export default function ReportContent({ alreadyReported, jobId }: ReportContentProps) {
    const [openModal, setOpenModal] = useState(false);

    const [msg, formAction] = useFormState(flagContent, initialMessage);

    return <>
        <Modal className="bg-white dark:bg-custom-dark" dismissible show={openModal} onClose={() => setOpenModal(false)}>
            <form action={formAction}>
                <div className="border border-neutral-400 dark:border-neutral-600 shadow-md dark:shadow-neutral-600">
                    <Modal.Header className='p-2 bg-gray-100 dark:bg-custom-grey'>
                        <div className='flex flex-row items-center gap-2'>
                            <FaRegFlag className='inline mr-2' />
                            Report content
                        </div>                    
                    </Modal.Header>
                    {alreadyReported
                        ? <>
                            <Modal.Body className="bg-gray-100 dark:bg-custom-grey">
                                <div className="space-y-6 ">
                                    You have already reported this animation. Thank you for your vigilance.
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="bg-gray-100 dark:bg-custom-grey">
                                <Button className="rounded-none bg-transparent text-black darK:text-white border-black border-solid dark:border-white px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300" onClick={() => setOpenModal(false)}>OK</Button>
                            </Modal.Footer>
                        </>
                        : <>
                            <Modal.Body className="bg-gray-100 dark:bg-custom-grey">
                                <div className="space-y-6 custom-textarea">
                                    <Label htmlFor="reason">Please tell us in a few words why you are reporting this animation:</Label>
                                    <Textarea id="reason" name="reason" placeholder='examples: nsfw content, hateful content, spam...' className="rounded-none w-full h-32" required />
                                    <TextInput
                                        className="hidden"
                                        readOnly
                                        id="jobid"
                                        name="jobid"
                                        value={jobId} />
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="bg-gray-100 dark:bg-custom-grey">
                                <Button className="rounded-none bg-transparent text-black dark:text-white border-black border-solid dark:border-white px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300 mr-2" onClick={() => setOpenModal(false)}>Back</Button>
                                <SubmitButton
                                    className="rounded-none bg-transparent text-black dark:text-white border-black border-solid dark:border-white px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300"
                                    type="submit">
                                        <FaRegFlag className='mr-2 text-black dark:text-white' />Report</SubmitButton>
                                {msg &&
                                    <div key={msg.timestamp} className='fade-out flex flex-row items-center gap-2 px-4'>
                                        <Alert className='rounded-none'  color={msg.type}>{msg.message}</Alert>
                                    </div>}                            
                            </Modal.Footer>
                        </>
                    }
                </div>
            </form>
        </Modal>
        <Button size={'xs'} className="items-start rounded-none border-none bg-transparent text-black dark:text-white hover:scale-x-110 hover:ease-linear hover:duration-300"  onClick={() => setOpenModal(true)}>
            <FaRegFlag className='mr-2 text-black dark:text-white' />Report
        </Button>
    </>
}

